"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplaySize = exports.AspectRatio = void 0;
const RequiredOption_1 = require("../RequiredOption");
class AspectRatio {
    constructor({ width, height }) {
        this.toJSON = () => ({
            width: this.width,
            height: this.height,
        });
        this.width = width;
        this.height = height;
    }
}
exports.AspectRatio = AspectRatio;
AspectRatio.fromJSON = (json) => {
    const { width, height } = Object.assign({}, json);
    if (typeof width !== 'number' || Number.isNaN(width))
        throw new Error('.width must be a number');
    if (typeof height !== 'number' || Number.isNaN(height))
        throw new Error('.height must be a number');
    return new AspectRatio({ width, height });
};
class DisplaySize {
    constructor({ width, height }) {
        this.toJSON = () => ({
            width: this.width,
            height: this.height,
        });
        this.width = width;
        this.height = height;
    }
    get key() {
        return `${this.width}x${this.height}`;
    }
}
exports.DisplaySize = DisplaySize;
DisplaySize.fromJSON = (json) => {
    const { width, height } = Object.assign({}, json);
    if (typeof width !== 'number' || Number.isNaN(width))
        throw new Error('.width must be a number');
    if (typeof height !== 'number' || Number.isNaN(height))
        throw new Error('.height must be a number');
    return new DisplaySize({ width, height });
};
class CreativeFormatAspectRatio {
    constructor({ supportingAspectRatioId, aspectRatio, requiredOption, size, }) {
        this.toJSON = () => ({
            supportingAspectRatioId: this.supportingAspectRatioId,
            aspectRatio: this.aspectRatio,
            requiredOption: this.requiredOption,
            size: this.size,
        });
        this.supportingAspectRatioId = supportingAspectRatioId;
        this.aspectRatio = aspectRatio;
        this.requiredOption = requiredOption;
        this.size = size;
    }
}
CreativeFormatAspectRatio.fromJSON = (json) => {
    const { supportingAspectRatioId, requiredOption, aspectRatio, size } = Object.assign({}, json);
    const _requiredOption = requiredOption ? RequiredOption_1.default.fromJSON(requiredOption) : undefined;
    if (typeof supportingAspectRatioId !== 'string')
        throw new Error('.supportingAspectRatioId must be a string');
    return new CreativeFormatAspectRatio({
        supportingAspectRatioId,
        aspectRatio: AspectRatio.fromJSON(aspectRatio),
        requiredOption: _requiredOption,
        size: DisplaySize.fromJSON(size),
    });
};
exports.default = CreativeFormatAspectRatio;
